import { render } from "./ShowerStaffManage.vue?vue&type=template&id=f21d124c&scoped=true"
import script from "./ShowerStaffManage.vue?vue&type=script&lang=js"
export * from "./ShowerStaffManage.vue?vue&type=script&lang=js"

import "./ShowerStaffManage.vue?vue&type=style&index=0&id=f21d124c&scoped=true&lang=scss"

import exportComponent from "/home/brant/git/HeySensCloudWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21d124c"]])

export default __exports__